<!-- Путевые листы -->
<template>
  <li
    v-if="canSeePage('waybills')"
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Waybills')"
    @mouseup="handleMiddleClick($event, 'Waybills')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Waybills')"
    :class="{ active: activeItem === 'waybills' }"
    :title="collapsed ? 'Путевые листы' : ''"
  >
    <div class="link-icon_box">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="#00bfa5"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 2.75C9 2.34 9.34 2 9.75 2H14.25C14.66 2 15 2.34 15 2.75V3H17C18.66 3 20 4.34 20 6V19C20 20.66 18.66 22 17 22H7C5.34 22 4 20.66 4 19V6C4 4.34 5.34 3 7 3H9V2.75ZM9.25 5C8.56 5 8 5.56 8 6.25C8 6.66 8.34 7 8.75 7H15.25C15.66 7 16 6.66 16 6.25C16 5.56 15.44 5 14.75 5H9.25Z"
        />
        <path
          d="M8.5 10.25C8.5 9.56 9.06 9 9.75 9C10.44 9 11 9.56 11 10.25C11 10.94 10.44 11.5 9.75 11.5C9.06 11.5 8.5 10.94 8.5 10.25Z"
        />
        <path
          d="M13 10.25C13 9.7 13.45 9.25 14 9.25H16.25C16.8 9.25 17.25 9.7 17.25 10.25C17.25 10.8 16.8 11.25 16.25 11.25H14C13.45 11.25 13 10.8 13 10.25Z"
        />
        <path
          d="M8.5 15.75C8.5 15.06 9.06 14.5 9.75 14.5C10.44 14.5 11 15.06 11 15.75C11 16.44 10.44 17 9.75 17C9.06 17 8.5 16.44 8.5 15.75Z"
        />
        <path
          d="M13 15.75C13 15.2 13.45 14.75 14 14.75H16.25C16.8 14.75 17.25 15.2 17.25 15.75C17.25 16.3 16.8 16.75 16.25 16.75H14C13.45 16.75 13 16.3 13 15.75Z"
        />
      </svg>
    </div>
    <span v-if="!collapsed" class="nav-link">Путевые листы</span>
  </li>
</template>

<script>
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "WaybillsItem",
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
